// src/components/TennisLogo.tsx
import React from 'react';

const TennisLogo: React.FC = () => {
  return (
    <div className="flex items-center gap-2">
      <img
        src="/tennis-logo.png"
        alt="TennisHub"
        className="h-8 w-8 object-contain"
      />
      <span className="font-bold text-xl">TennisHub</span>
    </div>
  );
};

export default TennisLogo;